import React from 'react'
import PropTypes from 'prop-types'

import { Container, Divider } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import AuthenticationShell from 'shared/components/AuthenticationShell'

const CheckEmail = ({ email }) => (
  <AuthenticationShell
    headerText={
      <>
        <i className="icon far fa-envelope" /> Check your email
      </>
    }
  >
    <Container textAlign="center">
      <p>
        We've just sent an email to <strong>{email} </strong> with a link you'll need to click to
        reset your password.
      </p>
      <Divider hidden />
      <Link to={{ pathname: '/login/', search: location.search }}>
        <i className="fas fa-arrow-left icon" />
        Back to login
      </Link>
    </Container>
  </AuthenticationShell>
)

CheckEmail.propTypes = {
  email: PropTypes.string,
}

export default CheckEmail



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ResetPassword/CheckEmail.js